import Cookies, { CookieAttributes } from 'js-cookie'
import { FetchLocationResponse } from 'services/location/types'

export const ACCEPTED_PRIVACY_POLICY = 'acceptedPrivacyPolicy'
export const LOCATION = 'location'

let accessToken = undefined

const options = {
  sameSite: 'strict',
} as CookieAttributes

if (process.env.COOKIE_DOMAIN) {
  options.domain = process.env.COOKIE_DOMAIN
}

const get = Cookies.get

const save = (
  key: string,
  value: string | Record<string, unknown>,
  additionalOptions?: CookieAttributes,
) =>
  Cookies.set(
    key,
    value,
    additionalOptions ? { ...additionalOptions, ...options } : options,
  )

const remove = (key: string, additionalOptions?: CookieAttributes) =>
  Cookies.remove(
    key,
    additionalOptions ? { ...additionalOptions, ...options } : options,
  )

export default {
  get,
  save,
  remove,
  getAccessToken: () => accessToken,
  saveAccessToken: (token: string) => (accessToken = token),
  getLocation: () => {
    const location = get(LOCATION)

    if (location) {
      return JSON.parse(location) as FetchLocationResponse
    }
  },
  saveLocation: (location: FetchLocationResponse) =>
    save(LOCATION, location, { expires: 0.02 }),
  removeLocation: () => remove(LOCATION),
  logout: () => {
    remove(LOCATION)
  },
}
